import { Box } from "@mui/material";
import Race from "../../components/race/race";
function RaceDetails() {
  return <Box>{<Race />}</Box>;
}

export default RaceDetails;
